import Typography from '@mui/material/Typography'

interface TextWithIconProps
{
  icon: React.ReactNode
  text: string
  style: any
}

export const TextWithIcon = ({ icon, text, style }: TextWithIconProps) =>
{
  return(
    <div style={{ ...styles.container, ...style }}>
      {icon}
      <Typography noWrap sx={{ ml: 0.2 }} fontWeight="700" color="textSecondary">{text}</Typography>
    </div>)
}

const styles = {
  container: {
    flexWrap: "nowrap",
    display: 'flex' as 'flex',
    alignItems: 'center' as 'center',
    flex: 1,
    flexDirection: "row" as 'row',
  }
}